import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { useTranslation, withTranslation } from 'react-i18next';
import { Loading } from 'react-lib/dist/components-es';
import { Segment } from 'semantic-ui-react';
import i18n from 'i18next';

import FilteringContextProvider from '../../Filtering/FilteringContextProvider';
import InventoryOverviewForm from './InventoryOverviewForm';
import { filterActions } from '../../../behavior/filter/index';
import { dataViewActions } from '../../../behavior/dataview/index';
import {
  defaultFilterColumn,
  DELETED_OVERVIEW_TYPE,
  ENTITY_OVERVIEW_TYPE,
  GEN_ORG_UNIT,
  entityType,
  HISTORY_OVERVIEW_TYPE,
  recordOptionType,
} from '../../../constants';
import { getInventoryTitle } from '../../../utils';
import { initSelectors } from '../../../behavior/init';
import { inventoriesActions } from '../../../behavior/inventories';
import { useTitleDispatch } from '../../TitleContextProvider';
import { Inventory } from '../../../routes';
import { chemicalProductsActions } from '../../../behavior/chemicalProducts';
import DefaultFilterHandler from '../../Filtering/FiltersPanel/DeafultFilterHandler';
import { localStorage } from '../../../store';
import useUser from '@behavior/init/getUserV2';
import { connect } from 'react-redux';

type Props = {
  actions: any;
  allFilters: any;
  entityTypeProps: any;
  tableOptions: any;
  showBackendSwitch: any;
  defaultFilteredList: any;
  hazardList: any;
  dataViewList: any;
  id: number;
  inventoryTitleDetails: any;
  chemicalProductTitleDetails: any;
  history: any;
  location: any;
  isLoadingDataView: boolean;
  isLoadingDataViewError: boolean;
  latestDataViewId: number;
  sharedDataView: any;
  overviewType: any;
};

const InventoryOverview = ({
  actions,
  allFilters,
  entityTypeProps,
  tableOptions,
  showBackendSwitch,
  defaultFilteredList,
  hazardList,
  dataViewList,
  id,
  inventoryTitleDetails,
  chemicalProductTitleDetails,
  history,
  location,
  isLoadingDataView,
  isLoadingDataViewError,
  latestDataViewId,
  sharedDataView,
  overviewType,
}: Props) => {
  const { user } = useUser();
  const { t } = useTranslation();
  const dispatch = useTitleDispatch();
  const localStorageValue = localStorage.getItem('defaultFilteredListOverride');
  let defaultFilteredListOverride = localStorageValue ? JSON.parse(localStorageValue) : null;

  const getUserDefaultFilterProp = () => {
    let tempUserDefaultFilterProp = location?.state?.userDefaultFilterProp;
    if (new URLSearchParams(window.location.search).get('GEN_TRADE_CHEMICAL_NAMES'))
      tempUserDefaultFilterProp = [defaultFilterColumn.GEN_TRADE_CHEMICAL_NAMES];
    if (overviewType === DELETED_OVERVIEW_TYPE) {
      tempUserDefaultFilterProp = [defaultFilterColumn.HIST_IS_DELETED];
    }
    return tempUserDefaultFilterProp;
  };

  const userDefaultFilterProp = getUserDefaultFilterProp();

  const [userDefaultFilterPropStateObj, setUserDefaultFPSO] = useState<any>();

  useEffect(() => {
    if (JSON.stringify(userDefaultFilterProp) !== JSON.stringify(userDefaultFilterPropStateObj)) {
      setUserDefaultFPSO(userDefaultFilterProp);
    }
  });

  let newSelectedDataViewIdProp =
    location && location.state && location.state.newSelectedDataViewId;

  let chemicalProductId = location && location.state && location.state.chemicalProductId;

  useEffect(() => {
    if (isLoadingDataView) {
      actions.initializeFiltering(
        entityTypeProps,
        latestDataViewId,
        overviewType === DELETED_OVERVIEW_TYPE
        // userDefaultFilterPropStateObj?.includes(defaultFilterColumn.GEN_IS_CHECK_VALID)
      ); // , id !== undefined ifPathVariable Id exists, than
      // we should load in-memory default dataview. It is used for links like "My chemicals", "Chemical product's inventory"
    }
  }, [isLoadingDataView]);

  useEffect(() => {
    if (isLoadingDataViewError) {
      actions.getDefaultDataView(entityTypeProps, -1, -1, overviewType === DELETED_OVERVIEW_TYPE);
    }
  }, [isLoadingDataViewError]);

  useEffect(() => {
    const newLatestDataViewId = newSelectedDataViewIdProp
      ? newSelectedDataViewIdProp
      : userDefaultFilterPropStateObj
      ? -1
      : null;
    //actions.initializeFiltering(entityTypeProps);
    actions.getDataViewList(entityTypeProps);
    actions.getDefaultDataView(
      entityTypeProps,
      id,
      newLatestDataViewId,
      overviewType === DELETED_OVERVIEW_TYPE
    );

    if (entityTypeProps === entityType.inventoryHist && id) actions.getInventoryTitleDetails(id);
    else if (chemicalProductId > 0) actions.getChemicalProductTitleDetails(chemicalProductId);

    return function cleanup() {
      actions.clearDefaultFilteredList();
    };
  }, [userDefaultFilterPropStateObj, newSelectedDataViewIdProp]);

  useEffect(() => {
    updateTitle();
  }, [
    i18n.language,
    id,
    userDefaultFilterPropStateObj,
    chemicalProductTitleDetails,
    inventoryTitleDetails,
  ]);

  const updateTitle = () => {
    if (entityTypeProps === entityType.inventory) {
      if (userDefaultFilterPropStateObj && userDefaultFilterPropStateObj.includes(GEN_ORG_UNIT)) {
        dispatch((prevState: any) => ({
          ...prevState,
          pageTitle: t('inventory.overview.page.my.department.inventories.title'),
        }));
      } else if (userDefaultFilterPropStateObj?.includes('GEN_CONTACTS')) {
        dispatch((prevState: any) => ({
          ...prevState,
          pageTitle: t('inventory.overview.page.my.inventories.title'),
        }));
      } else if (
        userDefaultFilterPropStateObj &&
        userDefaultFilterPropStateObj.includes('GEN_LOCATION_NAME')
      ) {
        dispatch((prevState: any) => ({
          ...prevState,
          pageTitle: t('inventory.overview.page.my.buildings.inventories.title'),
        }));
      } else if (
        typeof id === 'undefined' &&
        typeof userDefaultFilterPropStateObj === 'undefined'
      ) {
        dispatch((prevState: any) => ({
          ...prevState,
          pageTitle: t('page.inventory.overview.title'),
        }));
      } else if (chemicalProductTitleDetails) {
        dispatch((prevState: any) => ({
          ...prevState,
          pageTitle: t('inventory.overview.page.has.product.title', {
            title: chemicalProductTitleDetails.tradeName,
          }),
        }));
      } else {
        dispatch((prevState: any) => ({
          ...prevState,
          pageTitle: t('page.inventory.overview.title'),
        }));
      }
    } else if (entityTypeProps === entityType.inventoryHist) {
      if (
        userDefaultFilterPropStateObj &&
        userDefaultFilterPropStateObj.includes(defaultFilterColumn.HIST_IS_DELETED)
      ) {
        dispatch((prevState: any) => ({
          ...prevState,
          pageTitle: t('inventory.overview.page.deleted.inventories.title'),
        }));
      } else if (inventoryTitleDetails) {
        let title = getInventoryTitle(inventoryTitleDetails, t);
        dispatch((prevState: any) => ({
          ...prevState,
          pageTitle: t('page.inventory.overview.history.title', { title: title }),
        }));
      }
    }
  };

  const filterProps = allFilters[entityTypeProps] || {};
  let isRenderExport = false;

  let isInventoryCanCreate = initSelectors.isInventoryOrChemProductCanCreate(
    user!,
    entityType.inventory
  );
  if (entityTypeProps === entityType.inventory) {
    isRenderExport = true;
    if (isInventoryCanCreate) {
      tableOptions = [
        recordOptionType.edit,
        recordOptionType.view,
        recordOptionType.clone,
        recordOptionType.delete,
      ];
    } else {
      tableOptions = [recordOptionType.edit, recordOptionType.view, recordOptionType.delete];
    }
  } else if (entityTypeProps === entityType.inventoryHist) {
    tableOptions = [recordOptionType.view];
    if (overviewType === DELETED_OVERVIEW_TYPE && isInventoryCanCreate)
      tableOptions.push(recordOptionType.undoDelete);
  }

  return !isLoadingDataView &&
    defaultFilteredList !== undefined &&
    entityTypeProps === defaultFilteredList.result.entityType &&
    filterProps.possibleFieldsList !== undefined &&
    filterProps.possibleFieldsList.length > 0 &&
    filterProps.visibleFieldsList.length > 0 &&
    filterProps.visibleColumnsList.length > 0 &&
    filterProps.visibleColumnsList.length > 0 &&
    (JSON.stringify(defaultFilteredList.result.entityType) ===
      JSON.stringify(entityType.inventory) ||
      JSON.stringify(defaultFilteredList.result.entityType) ===
        JSON.stringify(entityType.inventoryHist)) ? (
    <>
      <FilteringContextProvider
        parentId={id}
        userDefaultFilterProp={userDefaultFilterPropStateObj}
        visibleColumns={filterProps.visibleColumnsList}
        visibleFields={filterProps.visibleFieldsList}
        actions={actions}
        entityType={entityTypeProps}
        tableOptions={tableOptions}
        showBackendSwitch={showBackendSwitch}
        filterProps={filterProps}
        defaultFilteredList={defaultFilteredList}
        hazardList={defaultFilteredList.hazardList}
        sharedDataView={sharedDataView}
        selectedRows={{}}
        defaultFilteredListOverride={defaultFilteredListOverride}
      >
        <Segment basic>
          <InventoryOverviewForm
            dataViewList={dataViewList}
            handleAddNewInventoryClick={() => history.push(`${Inventory.baseName}/create`)}
            isRenderExport={isRenderExport}
            renderRowComparator={overviewType === HISTORY_OVERVIEW_TYPE}
          />
          <DefaultFilterHandler
            user={user}
            userDefaultFilterProp={userDefaultFilterPropStateObj}
            chemicalProductTitleDetails={chemicalProductTitleDetails}
          />
        </Segment>
      </FilteringContextProvider>
    </>
  ) : (
    <Loading isLoading={true} />
  );
};

InventoryOverview.defaultProps = {
  tableOptions: [],
  showBackendSwitch: false,
  hazardList: [],
};

const mapStateToProps = (state: any, ownProps: any) => ({
  ...state.filter,
  ...state.dataView,
  ...state.inventories,
  ...state.chemicalProducts,
  ...state.defaultFilteredList,
  ...state.latestDataViewId, //passed through getDefaultDataView from ViewOptionsContainer > FilteringContextProvider
  allFilters: state.filter,
  id: ownProps.match.params.id,
  entityTypeProps:
    ownProps.match.params.overviewType === HISTORY_OVERVIEW_TYPE ||
    ownProps.match.params.overviewType === DELETED_OVERVIEW_TYPE
      ? entityType.inventoryHist
      : entityType.inventory,
  overviewType: ownProps.match.params.overviewType,
  sharedDataView: state.dataView.sharedDataView,
});

const mapDispatchToProps = (dispatch: any) => ({
  actions: {
    deleteInventory: (id: number) => dispatch(inventoriesActions.deleteInventory(id, false)),
    initializeFiltering: (
      entityType: number,
      latestDataViewId: number,
      isDeleted: boolean,
      nonChecked: boolean
    ) =>
      dispatch(
        filterActions.initializeFiltering(entityType, latestDataViewId, isDeleted, nonChecked)
      ),
    applyFilterAction: (entityType: string, filterState: any, filters: any) =>
      dispatch(filterActions.applyFilterV2(entityType, filterState, filters)),
    clearSharedDataView: () => {
      dispatch(dataViewActions.clearSharedDataView());
    },
    getDefaultDataView: (
      entityType: string,
      id: number,
      latestDataViewId: number,
      isDeleted: boolean
    ) => {
      dispatch(dataViewActions.getDefaultDataView(entityType, id, latestDataViewId, isDeleted));
    },
    getDataViewList: (entityType: string) => dispatch(dataViewActions.getDataViewList(entityType)),
    getInventoryTitleDetails: (id: number) =>
      dispatch(inventoriesActions.getInventoryTitleDetails(id)),
    getChemicalProductTitleDetails: (id: number) =>
      dispatch(chemicalProductsActions.getChemicalProductTitleDetails(id)),
    clearDefaultFilteredList: () => dispatch(dataViewActions.clearDefaultFilteredList()),
  },
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(InventoryOverview);
